import symbolPrimary from "../assets/img/brand/symbolPrimary_cropped.svg";
import logoPrimary from "../assets/img/brand/logoPrimary_cropped.svg";
import { classNames } from "../utils/classNames";
import { useTranslation, useWhitelabel } from "../stores/RootStoreContext";
import { Icon } from "./Icon";
import { TMessage } from "../i18n/tt";

export type LogoProps = {
  linkUrl: string;
  full?: boolean;
  className?: string;
  tooltip?: TMessage;
  variant?: "default" | "back-button";
};

export function Logo(props: LogoProps) {
  const { t } = useTranslation();
  const whitelabel = useWhitelabel();
  const logo = whitelabel
    ? `/api/whitelabel/logo/${whitelabel.logoId}`
    : props.full
      ? logoPrimary
      : symbolPrimary;
  const height = props.full ? 34 : props.variant === "back-button" ? 20 : 24;
  const tooltip = props.tooltip ? t(props.tooltip) : undefined;

  switch (props.variant) {
    case "back-button":
      return (
        <a
          href={props.linkUrl}
          className={classNames(
            "tw-flex-none",
            "tw-p-2",
            "text-base",
            "tw-rounded",
            "tw-border",
            "border-gray",
            "color-default",
            "bg-primary-contrast",
            "hover:border-primary",
            "tw-group",
            "tw-relative",
            props.className,
          )}
          data-tooltip={tooltip}
        >
          <img
            src={logo}
            alt="dCompany"
            style={{ height }}
            className={"tw-visible group-hover:tw-invisible"}
          />
          <div className="tw-invisible group-hover:tw-visible tw-flex tw-absolute tw-inset-0 tw-items-center tw-justify-center">
            <Icon name="caret-left" color="default" />
          </div>
        </a>
      );
    default:
      return (
        <a
          href={props.linkUrl}
          className={classNames("tw-flex-none", props.className)}
          data-tooltip={tooltip}
        >
          <img src={logo} alt="dCompany" style={{ height }} />
        </a>
      );
  }
}
